import React from 'react';

const sniffDesc =
    "Sniffspot provides the best experiences and fun for you and your dog. Our dog parks are designed for the ultimate dog exercise. Our private spaces help you minimize distractions or triggers and maximize time with your dog. We provide off leash enrichment - exploration and activities you can't get anywhere else; wear your dog out for days. We make it easy to have playdates. Socialize your pup in a controlled, private spot - it's great exercise and it's fun for you and your dog.";

const RenderAbout = () => (
    <div className="sniff-top-listings">
        <div className="l-container">
            <h3 className="snif-m2 snif-l1-pc snif-semibold mb-2">About Sniffspot</h3>
            <p className="snif-s2 snif-p-pc mb-0">{sniffDesc}</p>
        </div>
    </div>
);

export default RenderAbout;
